import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@mui/material';

export default function SimpleBackdrop({open, onClick, msg}) {
//   const [open, setOpen] = React.useState(false);
//   const handleClose = () => {
//     setOpen(false);
//   };
//   const handleOpen = () => {
//     setOpen(true);
//   };

  return (
    <div>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1, flexDirection: 'column', gap: 5 })}
        open={open}
        onClick={onClick}
      >
        <CircularProgress color="inherit" />
        <Typography>
            {msg}
        </Typography>
      </Backdrop>
    </div>
  );
}